<!-- 由 suu 创建于 2021-04-06 星期二 -->
<template>
  <div class="loading" :style="loadingStyle">
    <img
      class="l-gif"
      src="https://cdnvue.gymcity.com.cn/uploads/loading-member"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: 'loading',

  components: {},

  props: {
    /**
     * 额外的上边距（单位：px），用于适配隐藏状态栏的页面
     * 例如传入状态栏高度，使loading与index.html中的loading保持相同位置
     */
    paddingTop: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {}
  },

  computed: {
    /**
     * 计算loading容器的样式
     * @returns {Object} 样式对象
     */
    loadingStyle() {
      // 基础padding-top为37.5vw（约等于141px在375px宽度的屏幕上）
      const basePaddingVw = 37.5
      // 将传入的px转换为vw（以375px为基准宽度）
      const extraPaddingVw = this.paddingTop ? (this.paddingTop / 375) * 100 : 0
      return {
        paddingTop: `${basePaddingVw + extraPaddingVw}vw`
      }
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.loading {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .l-gif {
    width: 100vw;
  }
}
</style>
